import React, { Fragment } from 'react';
import { withRouter } from 'react-router';
import { NavLink as Link } from 'react-router-dom';
import { FormattedMessage } from 'react-intl';
import { inject } from 'mobx-react';

import ChallengeTimer from '../challenge-card/challenge-timer.component.js';
import { RoundButton, PrimaryButton } from '../ui-toolkit/buttons.js';
import FormattedNumberCurrency from '../shared/formattedNumberCurrency.component.js';
import ExternalChallenge from '../external-challenge/external-challenge.component.js';

import solutionsIcon from '../../assets/images/solver-challenge-card/solutions.svg';
import viewsIcon from '../../assets/images/eye.svg';
import challengeTypeIcon from '../../assets/images/solver-challenge-card/challenge-type.svg';

import './seeker-challenge-details-card.scss';

const SeekerChallengeDetailsCard = ({
	title,
	award,
	deadline,
	solutionStats,
	status,
	challengeType,
	location: { search },
	authService,
	isExternal,
	externalLogo,
}) => (
	<div className="seeker-challenge-card">
		<h1>{title}</h1>

		<div className="d-flex info">
			{award && (
				<RoundButton className="prize" primary>
					<FormattedNumberCurrency
						number={award.amount}
						currency={award.currencyCode}
					/>
				</RoundButton>
			)}

			{deadline && (
				<ChallengeTimer
					classNames="deadline"
					deadline={deadline}
					status={status}
				/>
			)}
		</div>

		<div className="stats">
			{solutionStats && (
				<Fragment>
					<div className="d-flex mb-2">
						<div className="icon">
							<img src={viewsIcon} alt="views" />
						</div>

						<FormattedMessage
							id="challenge.card.views"
							values={{
								count: solutionStats.numberSolversVisits || 0,
							}}
						/>
					</div>

					{!isExternal && (
						<div className="d-flex mb-2">
							<div className="icon">
								<img src={solutionsIcon} alt="solutions" />
							</div>

							<FormattedMessage
								id="challenge.card.solutions"
								values={{
									count: solutionStats.numberSolutions || 0,
								}}
							/>
						</div>
					)}
				</Fragment>
			)}

			{challengeType && (
				<div className="stats-wrapper type">
					<div className="d-flex mb-2">
						<div className="icon">
							<img src={challengeTypeIcon} alt="solvers" />
						</div>

						<FormattedMessage
							id="challenge.card.type"
							values={{
								type: challengeType.name,
							}}
						/>
					</div>
				</div>
			)}

			{isExternal && externalLogo && externalLogo.url && (
				<ExternalChallenge externalLogo={externalLogo.url} />
			)}

		</div>

		{!authService.isLoggedIn && status !== 'EVALUATION' && status !== 'CLOSED' && (
			<Link to={search ? `/sign-up${search}` : '/sign-up'}>
				<PrimaryButton fullWidth className="button-sign-up">
					<FormattedMessage id="solver_challenge_card.sign_up_to_participate" />
				</PrimaryButton>
			</Link>
		)}
	</div>
);

export default withRouter(inject('authService')(SeekerChallengeDetailsCard));
